export * from 'cf-core/src/images'
export const Hero404 = 'https://d24rddnpxh8ji7.cloudfront.net/404Hero.png'
export const appStore =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/app-store.png'
export const cftitle =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/cftitle.png'
export const googlePlay =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/google-play.png'
export const user =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/user.png'
export const sharedBg =
  'https://d24rddnpxh8ji7.cloudfront.net/marblebgdefault.jpg'
export const orderStatusProgress =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1554602154/general/OrderStatusProgress.png'
export const orderStatusMeter =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1554666730/general/OrderStatusMeter.png'
export const promoHeader =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/Shaolin/promoHeader.png'
export const restaurant =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/v1562129124/Shaolin/restaurant.jpg'
export const yelp =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/v1601869832/general/yelp_white.png'
export const facebook =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1601869832/general/facebook_white.png'
export const twitter =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1669056666/general/twitter.png'
export const instagram =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1601869833/general/instagram_white.png'
export const contactMobilebg =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/contactMobilebg.jpg'
export const rewardbg =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/rewardbg.jpg'
export const downloadButton =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/downloadButton.png'
export const flowerTL =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/flowerTL.png'
export const flowerBR =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/flowerBR.png'
export const redeemButton =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/redeemButton.png'
export const pointsMeter =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/pointsMeter.png'
export const rewardArrowLeft =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/rewardArrowLeft.png'
export const rewardArrowRight =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/rewardArrowRight.png'
export const rewardDefault =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/rewardDefault.png'
export const viewMenu =
  'https://d24rddnpxh8ji7.cloudfront.net/hanabisushi/viewMenu2.webp'
export const cflogo = 'https://d24rddnpxh8ji7.cloudfront.net/cflogo.png'
export const about =
  'https://d24rddnpxh8ji7.cloudfront.net/hanabisushi/about2.webp'
export const contactbg =
  'https://d24rddnpxh8ji7.cloudfront.net/hanabisushi/contactBg.webp'
export const foodGallery =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1669055291/bananaLeaf/foodGallery_1.jpg'
export const hero =
  'https://d24rddnpxh8ji7.cloudfront.net/hanabisushi/herobg.webp'
export const heroText =
  'https://d24rddnpxh8ji7.cloudfront.net/hanabisushi/heroText.webp'
export const logo =
  'https://d24rddnpxh8ji7.cloudfront.net/hanabisushi/weblogo.webp'
export const locationMap =
  'https://d24rddnpxh8ji7.cloudfront.net/hanabisushi/locationMap.webp'
export const mobileAbout =
  'https://d24rddnpxh8ji7.cloudfront.net/hanabisushi/mobileAbout.webp'
export const mobileContactbg =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1635892528/vietmama/mobileContactbg.jpg'
export const mobileHero =
  'https://d24rddnpxh8ji7.cloudfront.net/hanabisushi/mobileHero.webp'
export const mobileLogo =
  'https://d24rddnpxh8ji7.cloudfront.net/hanabisushi/mobileLogo3.webp'
export const mobileMap =
  'https://d24rddnpxh8ji7.cloudfront.net/hanabisushi/mobileMap.webp'
export const orderPickupButton =
  'https://d24rddnpxh8ji7.cloudfront.net/hanabisushi/orderButton2.webp'
export const mobileGallery =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1669059169/bananaLeaf/mobileGallery.jpg'
export const promotions =
  'https://d24rddnpxh8ji7.cloudfront.net/hanabisushi/promotions2.webp'
export const mobilePromo =
  'https://d24rddnpxh8ji7.cloudfront.net/hanabisushi/mobilePromo.webp'
export const promo1 =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1669058702/bananaLeaf/promo1.jpg'
export const promo2 =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1669058702/bananaLeaf/promo2.jpg'
export const promo3 =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1669058702/bananaLeaf/promo3.jpg'
export const promo4 =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1669058702/bananaLeaf/promo4.jpg'
export const viewMenu2 =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1669921988/bananaLeaf/viewMenu2.png'
